module.exports = __webpack_public_path__ + "static/media/10x_Logo_Animation.a53ed690.mp4";